{
    "404": "ああ、大変！海中を探したのですが、ページが見つかりません！",
    "appError": {
        "title": "何らかの問題が発生しました",
        "description": "アプリで予期せぬ問題が発生しました。アプリを再読み込みするか、ワークスペースに戻ってください。この問題が繰り返し発生する場合は、サポートにお問い合わせください。",
        "home": "ワークスペースに戻る"
    }
}
